export default "__VITE_ASSET__RusjzxeR__"